import * as React from 'react';
import { Link } from '@tanstack/react-router';
import { motion } from 'framer-motion';
import { ArrowRight, MessageSquareHeart, Send, Star } from 'lucide-react';
import { fadeUp } from '@/constants/motion';
import { PillTag } from '@/components/pill-tag';
import { Card } from '@/components/ui/card';
export function FeedbackSpotlight() {
    return (<motion.section className="border-b bg-linear-to-b from-background to-muted/20" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }}>
            <div className="mx-auto max-w-6xl px-4 py-16 md:py-24">
                <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
                    <motion.div variants={fadeUp} transition={{ duration: 0.5 }}>
                        <PillTag label="New"/>
                        <h2 className="mt-4 text-3xl font-bold tracking-tight md:text-4xl">
                            Turn any QR into a feedback form.
                        </h2>
                        <p className="mt-4 text-base text-muted-foreground md:text-lg leading-relaxed">
                            Collect ratings and comments from the people who actually showed up — at the table,
                            on the packaging, in the showroom. Every submission lands in your Telegram chat in
                            real time, attributed to the QR or smart link that produced it.
                        </p>

                        <ul className="mt-6 space-y-3 text-sm text-muted-foreground">
                            <Bullet>One QR → public form (no login, no app install)</Bullet>
                            <Bullet>Ratings, comments, optional name & email</Bullet>
                            <Bullet>Telegram delivery — per-workspace default + per-campaign override</Bullet>
                            <Bullet>Submissions linked back to the originating scan for attribution</Bullet>
                        </ul>

                        <div className="mt-8 flex flex-wrap gap-3">
                            <Link to="/sign-up" search={{ redirect: '/console' }} className="inline-flex items-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90">
                                Try it free
                                <ArrowRight className="h-4 w-4"/>
                            </Link>
                            <Link to="/blog/feedback-campaigns" className="inline-flex items-center gap-2 rounded-md border bg-background px-4 py-2 text-sm font-medium hover:bg-muted">
                                Read the announcement
                            </Link>
                        </div>
                    </motion.div>

                    <motion.div variants={fadeUp} transition={{ duration: 0.5, delay: 0.1 }}>
                        <FeedbackPreview />
                    </motion.div>
                </div>
            </div>
        </motion.section>);
}
function Bullet({ children }) {
    return (<li className="flex gap-2">
            <span className="mt-1 inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-primary"/>
            <span>{children}</span>
        </li>);
}
function FeedbackPreview() {
    return (<Card className="overflow-hidden border bg-background shadow-sm">
            <div className="border-b bg-muted/40 px-5 py-3 text-xs uppercase tracking-wide text-muted-foreground">
                Public form
            </div>
            <div className="space-y-4 p-6">
                <div>
                    <h3 className="text-lg font-semibold">How was your visit?</h3>
                    <p className="text-sm text-muted-foreground">Beef &amp; Basil — Phnom Penh</p>
                </div>
                <div className="flex gap-1">
                    {[1, 2, 3, 4, 5].map((n) => (<Star key={n} className={n <= 4 ? 'h-6 w-6 fill-amber-400 text-amber-400' : 'h-6 w-6 text-muted-foreground/30'}/>))}
                </div>
                <div className="rounded-md border bg-muted/30 px-3 py-2 text-sm text-muted-foreground">
                    Loved the chili oil. Bring back the iced coffee special!
                </div>
            </div>
            <div className="border-t bg-primary/5 px-5 py-3 text-xs flex items-center gap-2 text-primary">
                <Send className="h-3.5 w-3.5"/>
                Delivered to <span className="font-mono">@beef-basil-feedback</span> on Telegram
            </div>
            <div className="border-t bg-background px-5 py-3 text-xs flex items-center gap-2 text-muted-foreground">
                <MessageSquareHeart className="h-3.5 w-3.5"/>
                Linked to scan from "Table 7 QR" · 3 minutes ago
            </div>
        </Card>);
}
